import React from 'react'
import NavLink from '../Routes/NavLink'

import { browserHistory } from 'react-router'
import {user} from '../../core/controllers/user';

export default class SettingsList extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillUpdate(nextProps, nextState) {

    }

    render(){
        return (
            <div>
                <div class="sub-page-header-row col-md-11">
                    <div class="row">
                        <span class="sub-page-header-title">Settings</span>
                    </div>
                </div>
                <div class="col-md-4 col-sm-5 col-xs-12">
                    <div class="card">
                        <div class="content settings-list">
                            <ul class="nav">
                                <li>
                                    <NavLink to="/settings/buildings/spaces/colorcodes/">
                                        <i class="icon-bar-chart-outline"></i>
                                        <p>Color Coding</p>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/settings/buildings/levels/statelisteners">
                                        <i class="icon-house-outline"></i>
                                        <p>Level State Listeners</p>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/settings/notifications/">
                                        <i class="icon-notification"></i>
                                        <p>Notifications</p>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/settings/quickbooks/">
                                        <i class="icon-person-outline"></i>
                                        <p>QB Enterprise Integration</p>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/settings/integrations/">
                                        <i class="icon-key-outline"></i>
                                        <p>Integrations</p>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/settings/import/">
                                        <i class="pe-7s-cloud-upload"></i>
                                        <p>Data Import</p>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/settings/referral/">
                                        <i class="pe-7s-gift"></i>
                                        <p>Referral Code</p>
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Settings/SettingsList.jsx